import React from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import styles from '../../styles/forms/attach_specification_to_plan_wizard/AddExistingSpecificationForm.scss';
import Button from '../../components/Button';
import { __, getLocalized } from '../../core/utils';
import Select from '../../components/Select';
import ButtonGroup from '../../components/ButtonGroup';
import Localization from '../../helpers/Localization';
import { subscribe } from 'react-contextual';

const AddExistingSpecificationForm = ({
  handleSubmit,
  possibleSpecificationCodes,
  submitting,
  onClose,
  localization,
  project_languages,
  application_language_id,
}) => {
  const { specification_groups, specification_subgroups } = localization;

  const possible_specification_codes = _.map(
    possibleSpecificationCodes,
    (specification) => {
      const specification_subgroup =
        _.get(specification_subgroups, [
          specification.specification_subgroup_id,
        ]) || {};
      const specification_group =
        _.get(
          specification_groups,
          _.get(specification_subgroup, 'specification_group_id')
        ) || {};

      const project_language_id = _.findKey(
        project_languages,
        (primary) => primary == true
      );

      const code =
        getLocalized(specification_group.code, project_language_id) +
        specification_subgroup.code +
        _.padStart(specification.code, 2, '0');
      const title = _.filter(
        [
          getLocalized(specification.description, application_language_id),
          specification.model,
          specification.brand,
        ],
        _.identity
      ).join(' / ');

      return {
        value: specification.id,
        label: _.filter([code, title], _.identity).join(': '),
      };
    }
  );

  return (
    <Form onSubmit={handleSubmit} className={styles.wrapper}>
      <div className={styles.form}>
        <Field
          name='specification_code_id'
          searchable
          component={Select}
          label={__('table.columns.choose-existing-specification')}
          options={possible_specification_codes}
        />
        <div className={styles.footer}>
          <Button
            lightGray
            medium
            left
            middleText={__('button.cancel')}
            onClick={onClose}
          />
          <ButtonGroup>
            <Button
              lightBlue
              medium
              submit
              middleText={__('button.attach')}
              spinning={submitting}
            />
          </ButtonGroup>
        </div>
      </div>
    </Form>
  );
};

export default reduxForm({
  form: 'attach_specification_to_plan_wizard.add_existing_specification_form',
})(subscribe(Localization, 'localization')(AddExistingSpecificationForm));
